export const performanceStages = {
    title: "Beispiel Leistungsstufen auf Basis Porsche 964",
    subtitle:
      "Drei Ausbaustufen – eine Leidenschaft. Vom original revidierten 3.6 bis zum 4.0-Liter-Hochleistungs-Saugmotor mit 400 PS. Handgefertigt für Enthusiasten, die mehr wollen.",
    stages: [
      {
        id: "stage-1",
        level: "Stufe 1",
        name: "Serien-Revision",
        targetAudience: "Originalgetreue Restauration & Werterhalt",
        description:
          "Komplette Instandsetzung des originalen 964-Motors mit Austausch aller Verschleißteile. Serienleistung, hohe Alltagstauglichkeit, perfekte Basis für Werterhalt.",
        features: [],
        link: "/motorenbau/stufe-1",
      },
      {
        id: "stage-2",
        level: "Stufe 2",
        name: "3.8 Performance",
        targetAudience: "Restomods & sportliche Straßenfahrzeuge",
        description:
          "Hubraumerweiterung auf 3.8 Liter, Sportnockenwellen, optimierter Ansaugtrakt, abgestimmte Elektronik. Ca. 320–350 PS für straßenzugelassene Performance mit Charakter.",
        features: [
          "Mit TÜV-Gutachten",
          "Leistungsdiagramm (Dyno)",
          "Komplett neu aufgebaut & optisch veredelt",
        ],
        link: "/motorenbau/stufe-2",
      },
      {
        id: "stage-3",
        level: "Stufe 3",
        name: "4.0 High-End",
        targetAudience: "Rennstrecke & kompromisslose Enthusiasten",
        description:
          "Leistungsstarker Saugmotor mit bis zu 400 PS. Einzeldrosselklappen, Titanpleuel, Rennsportkomponenten. Für Fahrer, die kompromisslose Technik suchen.",
        features: [
          "Mit TÜV-Gutachten",
          "Leistungsdiagramm (Dyno)",
          "Komplett neu aufgebaut & optisch veredelt",
        ],
        link: "/motorenbau/stufe-3",
      },
    ],
  };
  